<template>
  <div class="card table-container mt-4 mt-md-2" v-if="clubs">
    <div class="card-header border-0 pl-2 pt-2">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Club Info</h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table :data="clubs">
        <template slot="columns">
          <th>Logo</th>
          <th>Club Name</th>
          <th>Edit</th>
          <!-- <th>Delete</th> -->
        </template>

        <template slot-scope="{row}">
          <td class="td-avatar">
            <span class="avatar avatar-sm rounded-circle">
              <img :src="row.avatar" />
            </span>
          </td>
          <td>{{row.clubName}}</td>

          <td class="pl-1">
            <button class="btn btn-info" @click="onEditClicked(row.id)">
              <img src="@/assets/icons/ic_edit.svg" /> Edit
            </button>
          </td>
        </template>
      </base-table>
      <div class="card-footer d-flex justify-content-center">
        <base-pagination :page-count="totalPage" v-model="pagination" @input="onPageChanged"></base-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { GET_CLUBS } from '@/store/actions.type'

import { paginate } from '@/common/utils'

export default {
  name: 'club-info-table',
  data() {
    return {
      club: null,
      pagination: 1,
      currentPage: 1,
      showModal: false
    }
  },
  created() {
    this.$store.dispatch(GET_CLUBS)
  },
  methods: {
    onPageChanged(page) {
      this.currentPage = page
    },
    onEditClicked(id) {
      this.$emit('edit', id)
      // this.$router.push({ path: `streamer/${id}` })
    }
    /* onDeleteClicked(club) {
      this.showModal = true
      this.club = club
    },
    onConfirmDelete() {
      this.$store.dispatch(DELETE_CLUB, this.club)
    } */
  },
  computed: {
    ...mapState({
      totalClubs: state => state.club.totalClubs,
      totalPage: state => state.club.totalPage,
      isLoading: state => state.club.isLoading,
      error: state => state.club.errror
    }),
    clubs() {
      return paginate(this.totalClubs, 10, this.currentPage)
    }
  }
}
</script>
<style scoped>
.td-avatar {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.btn-info {
  padding: 0.45rem 0.8rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
}
.btn-delete {
  padding: 0.45rem 0.8rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
  background-color: #f65858;
}
.btn-delete:hover {
  background-color: #f65858;
}
.btn-success {
  padding: 0.45rem 1.2rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}
.default-button {
  padding: 0.625rem 1.25rem !important;
  font-size: 0.875em !important;
}
.btn-cancel {
  border-color: #f65858 !important;
  color: #f65858 !important;
}
.btn-cancel:hover {
  background-color: transparent !important;
}
</style>
